import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { FormInputProps } from "@/types";
import { BundleServiceId } from "@/constants/supplyPoint";

export const KettleType = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);
  const { serviceProducts } = useContext(EnumerationsContext);

  const boilerTypes = serviceProducts
    .filter(service => service.bundleServiceId === BundleServiceId)
    .map(service => ({
      value: service.id,
      label: service.name,
    }));
  return <Select label={t("supplyPoint:kettleData.kettleBrandType")} data={boilerTypes} {...props} />;
};
